import React, { Component } from "react";
import Layout from "../../../Layout/layout";
import Helmet from "react-helmet";
import ReportButtonGroup from "../../commoncomponents/reportButtonGroup";
import "../../../styles/reports/reports.scss";
import "../../../styles/tools/colors.scss";
import { Table, Button } from "react-bootstrap";
import HighlightedDetailTab from "../../commoncomponents/highlightedDetailTab";
import Calendar from "react-calendar/dist/umd/Calendar";
import {
  setLoadingPage,
  setErrorMessage,
  setHeaderVisible,
  setReportAssetId,
  setReportCalendatDate,
  setReportAssetName,
} from "../../../reducers/actions";
import { connect } from "react-redux";
import Summary from "../common/summary";
import OverSpeedException from "./overspeedExceptions";
import RawMessagesEvents from "./rawMessagesEvents";
import axios from "axios";
import { apiHost } from "../../../api/apiClient";
import moment from "moment";
import VisitLog from "./visitLog";
import VisitMap from "../../maps/visitMap";
import "@emotion/core";
import GridLoader from "react-spinners/GridLoader";
import AssetInforWarning from "../../commoncomponents/assetInforWarning";
import GroupWarning from "../../commoncomponents/groupWarning";
import queryString from "query-string";
import { GetLocationAddress } from "../../../utils/mapapi";

class Visit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      assetPlaceholder: "Select Asset",
      dataPlaceholder: moment().format("dddd Do MMMM, YYYY"),
      assetShow: false,
      groupTabHighlight: true,
      assetTabHighlight: false,
      groupTabHeading: true,
      assetTabHeading: true,
      groupCustomerName: "",
      groupGeneralName: "",
      assetCustomerName: "",
      assetGeneralName: "",
      ReportDate: moment().format("YYYY-MM-DD"),
      calendarSelectedDate: new Date(),
      calendarShow: false,
      checked: true,
      groupDetails: [],
      groupId: "",
      AssetList: [],
      assetId: "",
      reportDetails: [],
      assetLoader: true,
      reportLoader: false,
      generatedDate: moment().format("DD-MM-YYYY hh:mm a"),
      assetSelectionBoolean: false,
      visitMapPoints: [],
      subTripPoints: [],
      errorLoader: false,
      isLoading: false,
    };
    this.groupId = "";
    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  async componentDidMount() {
    const values = queryString.parse(this.props.location.search);

    if (values.assetId) {
      if (values.assetDate !== undefined && values.assetDate !== "null") {
        await this.setState({
          dataPlaceholder: moment(values.assetDate).format("dddd Do MMMM, YYYY"),
          ReportDate: values.assetDate,
        });
      }

      await this.setState({
        assetPlaceholder: values.assetName,
        assetCustomerName: values.assetName,
        assetId: values.assetId,
      });

      this.handleCreateReport();
    } else if (this.props.reportAssetId != "") {
      alert("true");
    }
    try {
      let GroupList = await axios.post(
        `${apiHost}/api/Notification/AllGroupForNotification`,
        {},
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );

      if (GroupList.status === 200) {
        this.setState({ isLoading: false, groupDetails: GroupList.data });
      } else {
        this.setState({ isLoading: true });
      }
    } catch (e) {
      console.log(`😱 Axios request failed: ${e}`);
    }
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  /**
   * Set the wrapper ref
   */
  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  /**
   * Alert if clicked on outside of element
   */
  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.setState({ calendarShow: false });
    }
  }

  getAssets = async () => {
    try {
      let AssetList = await axios.get(`${apiHost}/api/Notification/AssetsByGroupId/${this.groupId}?IsReport=true`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });

      this.setState({
        AssetList: AssetList.data.paggedlist,
        assetLoader: false,
      });
    } catch (e) {
      console.log(`😱 Axios request failed: ${e}`);
    }
  };

  handleGroupSelection = (customer, name, id) => {
    this.setState({ assetLoader: true });
    this.groupId = id;
    this.setState({
      groupId: id,
      groupCustomerName: customer,
      groupGeneralName: name,
      assetCustomerName: "",
      assetGeneralName: "",
      assetTabHeading: true,
      groupTabHighlight: false,
      assetTabHighlight: true,
      groupTabHeading: false,
    });
    this.getAssets();
  };

  handleAssetSelection = (asset, name, id) => {
    this.setState({
      assetId: id,
      assetCustomerName: asset,
      assetGeneralName: name,
      assetTabHighlight: false,
      assetTabHeading: false,
    });
  };

  toggleGroupTable = () => {
    let assetClosingBoolean = !this.state.groupTabHighlight;
    this.setState({
      groupTabHighlight: !this.state.groupTabHighlight,
    });

    if (assetClosingBoolean) {
      this.setState({
        assetTabHighlight: false,
      });
    }
  };

  toggleAssetTable = () => {
    let groupClosingBoolean = !this.state.assetTabHighlight;

    this.setState({
      assetTabHighlight: !this.state.assetTabHighlight,
    });
    if (groupClosingBoolean) {
      this.setState({
        groupTabHighlight: false,
      });
    }
  };

  truckFunction = () => {
    this.setState({
      assetShow: !this.state.assetShow,
    });
  };

  calendarFunction = () => {
    this.setState({
      calendarShow: !this.state.calendarShow,
    });
  };

  onChangeDate = (date) => {
    this.setState({
      calendarSelectedDate: date,
      ReportDate: moment(date).format("YYYY-MM-DD"),
      dataPlaceholder: moment(date).format("dddd Do MMMM, YYYY"),
      calendarShow: false,
    });
  };

  handleCheckup = () => {
    this.setState({
      checked: !this.state.checked,
    });
  };

  handleWindow = () => {
    this.props.setHeaderVisibleAction(!this.props.headerHide);
  };

  handleCreateReport = async () => {
    this.setState({
      reportDetails: [],
      assetSelectionBoolean: true,
      reportLoader: true,
      generatedDate: moment().format("DD-MM-YYYY hh:mm a"),
    });

    let assetID = this.state.assetId;
    let assetName = this.state.assetCustomerName;
    this.props.setReportAssetIdAction(assetID);
    this.props.setReportAssetNameAction(assetName);
    this.props.setReportCalendatDateAction(this.state.ReportDate);

    try {
      let ReportDetails = await axios.post(
        `${apiHost}/api/Report/Visit`,
        {
          AssetId: this.state.assetId,
          SearchDate: this.state.ReportDate,
          Timezone: localStorage.getItem("timeZoneID"),
          UseFiltering: this.state.checked,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      this.setState({
        reportLoader: false,
        errorLoader: false,
      });

      this.setState({ reportDetails: ReportDetails.data });

      if (ReportDetails.data.assetMapDay.mapObjects.length > 0) {
        this.setVisitMapPoints(ReportDetails.data.assetMapDay.mapObjects, ReportDetails.data.assetMapDay.startPosition);
      }

      if (ReportDetails.data.assetMapDay.tripMapObjects.length > 0) {
        await this.SetAddress(ReportDetails.data.assetMapDay.tripMapObjects);
        this.setSubVisitPoints(ReportDetails.data.assetMapDay.tripMapObjects);
      }
    } catch (e) {
      console.log(`😱 Axios request failed: ${e}`);
      this.setState({
        reportLoader: false,
        errorLoader: true,
      });
    }
  };

  SetAddress = async (data) => {
    const newsubtriparray = await Promise.all(
      data.map(async (item) => {
        if (!item.address) {
          item.address = await GetLocationAddress(item.lastMessage.gPRMC.latitude, item.lastMessage.gPRMC.longitude);
        }
        return item;
      })
    );
    return newsubtriparray;
  };

  setSubVisitPoints = (data) => {
    var subTripPoints = [];
    data.forEach((element) => {
      if (element.lastMessage != null) {
        const obj = {
          lat: element.lastMessage.gPRMC.latitude,
          lng: element.lastMessage.gPRMC.longitude,
          arrived: element.arrived,
          departed: element.departed,
          parked: element.parked,
          address: element.address,
          assetName: element.assetName,
          name: element.positionName,
          fridge: element.lastMessage.iO1 == 1 ? "On" : "Off",
          tempA: element.lastMessage.sensorAValue,
          tempB: element.lastMessage.sensorBValue,
        };
        subTripPoints.push(obj);
      }
    });
    this.setState({ subTripPoints });
  };

  setVisitMapPoints = (data, start) => {
    var visitMapPoints = [];

    data.forEach((subTrip) => {
      subTrip.tripMapPoints.forEach((single, index) => {
        if (index == 0) {
          const pointObj = {
            lat: single.latitude,
            lng: single.longitude,
            angle: single.heading,
            name: start.positionName,
            assetName: start.assetName,
            address: start.address,
            parked: start.parked,
            speed: start.speed,
            recieved: start.received,
          };
          visitMapPoints.push(pointObj);
        } else {
          const pointObj = {
            lat: single.latitude,
            lng: single.longitude,
            angle: single.heading,
          };
          visitMapPoints.push(pointObj);
        }
      });
    });

    this.setState({ visitMapPoints });
  };

  render() {
    const GroupTable = (
      <div className={this.state.groupTabHighlight ? "tableHeight" : "tableSmoothHeight"}>
        <Table striped responsive hover>
          <thead>
            <tr>
              <th>Customer</th>
              <th>Name</th>
              <th>Description</th>
            </tr>
          </thead>
          <tbody>
            {this.state.groupDetails.map((item, index) => {
              return (
                <tr
                  className="trRow"
                  title="click to select"
                  id="1"
                  onClick={(e) => this.handleGroupSelection(item.customername, item.groupName, item.groupId)}
                >
                  <td>{item.customername}</td>
                  <td>{item.groupName}</td>
                  <td>{item.description}</td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
    );

    const AssetTable = (
      <div className={this.state.assetTabHighlight ? "tableHeight" : "tableSmoothHeight"}>
        {this.state.AssetList != "" ? (
          <Table striped hover>
            <thead>
              <tr>
                <th>Name</th>
                <th>Description</th>
                <th>Customer</th>
              </tr>
            </thead>
            <tbody>
              {this.state.AssetList.map((item, index) => {
                return (
                  <tr
                    className="trRow"
                    title="click to select"
                    id="1"
                    onClick={(e) => this.handleAssetSelection(item.name, item.customerName, item.assetId)}
                  >
                    <td>{item.name}</td>
                    <td>{item.description}</td>
                    <td>{item.statusId}</td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        ) : (
          <AssetInforWarning warningText={true} warningTextMsg=" No assets found" />
        )}
      </div>
    );

    const data = (
      <div className={this.state.assetShow ? "dropDownContainer smoothHeight" : "dropDownContainer"}>
        {!this.state.isLoading && this.state.groupDetails.length > 0 ? (
          <div className="dropDownContentMainContainer">
            <div className="dropDownHeading">
              {this.state.groupTabHeading ? (
                <h1>1. Select Group</h1>
              ) : (
                <HighlightedDetailTab
                  leftIcon="fa-th"
                  functionCall={this.toggleGroupTable}
                  click={this.state.groupTabHighlight}
                  customerName={this.state.groupCustomerName}
                  generalName={this.state.groupGeneralName}
                  count="114"
                />
              )}
            </div>
            <div className="dropDownContent">{GroupTable}</div>
            <br />
            {this.state.groupId != "" ? (
              <div>
                <div className="dropDownHeading">
                  {this.state.assetTabHeading ? (
                    <h1>2. Select Asset</h1>
                  ) : (
                    <HighlightedDetailTab
                      leftIcon="fa-truck"
                      click={this.state.assetTabHighlight}
                      functionCall={this.toggleAssetTable}
                      customerName={this.state.assetCustomerName}
                      generalName={this.state.assetGeneralName}
                      count="34"
                    />
                  )}
                </div>
                {!this.state.assetLoader ? (
                  <div className="dropDownContent">{AssetTable}</div>
                ) : (
                  <center>
                    <GroupWarning
                      warningText={true}
                      warningTextHead="No Groups Found"
                      warningTextBody=" You do not have any group memberships. Please contact Support to ensure your account configured correctly."
                    />
                    <br />
                  </center>
                )}
              </div>
            ) : (
              ""
            )}

            <div className="dropDownFooter">
              <Button
                variant="outline-secondary"
                onClick={() => {
                  this.setState({ assetShow: false });
                }}
              >
                Cancel
              </Button>
              &nbsp;
              {this.state.assetCustomerName != "" && this.state.groupGeneralName != "" ? (
                <Button
                  onClick={() => {
                    this.setState({
                      assetShow: false,
                      assetPlaceholder: this.state.assetCustomerName,
                    });
                  }}
                  variant="success"
                >
                  OK
                </Button>
              ) : (
                <Button variant="success" disabled>
                  OK
                </Button>
              )}
            </div>
          </div>
        ) : (
          this.state.isLoading && (
            <center>
              <br />
              <GroupWarning
                warningText={true}
                warningTextHead="No Groups Found"
                warningTextBody=" You do not have any group memberships. Please contact Support to ensure your account configured correctly."
              />
              <br />
            </center>
          )
        )}
      </div>
    );

    const calendarReport = this.state.calendarShow ? (
      <div ref={this.setWrapperRef} className="ParentCalender" style={{ position: "relative", zIndex: 100 }}>
        <div className="CalendarContainer" style={{ position: "absolute" }}>
          <Calendar maxDate={new Date()} onChange={this.onChangeDate} value={this.state.calendarSelectedDate} />
        </div>
      </div>
    ) : (
      ""
    );

    return (
      <Layout>
        <Helmet>
          <title>Visit Report</title>
        </Helmet>
        <div className="contentBody">
          <div className={!this.props.headerHide ? `contentWrapper contentWrapperSmoothRelease` : `contentWrapper contentWrapperSmooth`}>
            <div className="headingContainer">
              <h2 className="mainHeading">
                Visit Report <span>v2.6.4</span>
              </h2>
              <i className={this.props.headerHide ? `fa fa-window-restore` : `fa fa-window-maximize`} onClick={this.handleWindow} />
            </div>
            <hr />
            <div className="inputFormGroup">
              <div className="inputElement">
                <ReportButtonGroup function={this.truckFunction} dropDown={data} placeholder={this.state.assetPlaceholder} icon="fa-truck" />
              </div>
              <div className="inputElement">
                <ReportButtonGroup
                  function={this.calendarFunction}
                  dropDown={calendarReport}
                  placeholder={this.state.dataPlaceholder}
                  icon="fa-calendar"
                />
              </div>
              <div className="inputElement">
                <p>
                  <input type="checkbox" onChange={this.handleCheckup} checked={this.state.checked}></input> Use Filtering{" "}
                </p>

                {this.state.assetId != "" ? (
                  <Button variant="outline-secondary" onClick={this.handleCreateReport} size="sm">
                    {" "}
                    Create Report{" "}
                  </Button>
                ) : (
                  <Button variant="outline-secondary" onClick={this.handleCreateReport} size="sm" disabled>
                    {" "}
                    Create Report{" "}
                  </Button>
                )}
              </div>
            </div>
            {this.state.assetSelectionBoolean ? (
              <div className="reportBody">
                {this.state.reportLoader ? (
                  <div className="loaderLine">
                    <br /> <GridLoader size={7} color={"#222222"} loading={this.state.reportLoader} />
                    <h1> &nbsp;Generating Report</h1>
                    <br />
                  </div>
                ) : this.state.errorLoader ? (
                  <AssetInforWarning warningText={true} warningTextMsg="No Data Available" />
                ) : (
                  <React.Fragment>
                    {this.state.reportDetails.processed != 0 ? (
                      <React.Fragment>
                        <Summary reportDetail={this.state.reportDetails} generatedDate={this.state.generatedDate} />
                        <VisitMap
                          depot={this.state.reportDetails.depot}
                          visitMapPoints={this.state.visitMapPoints}
                          subTripPoints={this.state.subTripPoints}
                        />
                        {this.state.reportDetails.trips != null && this.state.reportDetails.trips.length > 0 && (
                          <VisitLog
                            reportDetail={this.state.reportDetails.trips}
                            assetCustomerName={this.state.assetPlaceholder}
                            calendarSelectedDate={this.state.calendarSelectedDate}
                            tempAEnabled={this.state.reportDetails.tempA}
                            tempBEnabled={this.state.reportDetails.tempB}
                            driverIDEnabled={this.state.reportDetails.driverID}
                            assetId={this.state.assetId}
                          />
                        )}
                        {this.state.reportDetails.speedExceptions != null && this.state.reportDetails.speedExceptions.length > 0 && (
                          <OverSpeedException
                            reportDetail={this.state.reportDetails.speedExceptions}
                            assetCustomerName={this.state.assetPlaceholder}
                            calendarSelectedDate={this.state.calendarSelectedDate}
                          />
                        )}
                        {this.state.reportDetails.rawMessagesEvents != null && this.state.reportDetails.rawMessagesEvents.length > 0 && (
                          <RawMessagesEvents
                            reportDetail={this.state.reportDetails.rawMessagesEvents}
                            assetCustomerName={this.state.assetPlaceholder}
                            calendarSelectedDate={this.state.calendarSelectedDate}
                            tempAEnabled={this.state.reportDetails.tempA}
                            tempBEnabled={this.state.reportDetails.tempB}
                            driverIDEnabled={this.state.reportDetails.driverID}
                          />
                        )}
                      </React.Fragment>
                    ) : (
                      <AssetInforWarning warningText={true} warningTextMsg="No Data Available" />
                    )}
                  </React.Fragment>
                )}
              </div>
            ) : (
              <AssetInforWarning />
            )}
          </div>
        </div>
      </Layout>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: state.loading,
  headerHide: state.headerHide,
  reportAssetId: state.reportAssetId,
});
const mapDispatchToProps = {
  setLoadingPageAction: setLoadingPage,
  setErrorMessageAction: setErrorMessage,
  setHeaderVisibleAction: setHeaderVisible,
  setReportAssetIdAction: setReportAssetId,
  setReportCalendatDateAction: setReportCalendatDate,
  setReportAssetNameAction: setReportAssetName,
};

export default connect(mapStateToProps, mapDispatchToProps)(Visit);
